<template>
  <el-drawer
    title=""
    :visible.sync="showConnectDrawer"
    :with-header="false"
    :append-to-body="true"
    :modal="false"
    :wrapperClosable="false"
  >
    <div class="addDrawerTitle">
      {{ $t(`authorization.resGroup.connectRes`) }}
    </div>
    <el-tree
      :data="treeData"
      :props="defaultProps"
      show-checkbox
      node-key="id"
      :default-checked-keys="defaultTree"
      ref="tree"
      check-strictly="true"
      @check-change="handleCheckChange"
    ></el-tree>
    <div class="bottomBtns">
      <el-button class="yesBtn" type="primary" @click="confirm()">{{
        $t(`common.confirm`)
      }}</el-button>
      <el-button class="noBtn" @click="cancel()">{{
        $t(`common.cancel`)
      }}</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { getResourceTree } from "@/api/authorization.js";
export default {
  name: "connectResourceDrawer",
  props: {
    showConnectDrawer: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      defaultTree: [],
      checkedNodes: [],
      treeData: [],
      defaultProps: {
        children: "childNode",
        label: "label",
      },
      true: true,
      false: false,
    };
  },
  watch: {
    selectedItems(val) {
      if (val.length > 0) {
        this.getTreeData();
      }
    },
  },
  mounted() {
    if (this.selectedItems.length > 0) {
      this.getTreeData();
    }
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
  },
  methods: {
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes();
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
      this.checkedNodes = this.getCheckedNodes();
    },
    getTreeData() {
      let data = {
        currentPage: 0,
        pageSize: 0, //传0说明不用分页
        condition: {
          org: this.selectedItems[0].org,
          resGroupCode: this.selectedItems[0].resGroupCode,
        },
      };
      getResourceTree(data).then((res) => {
        //基础功能不能编辑
        res.data.list.forEach((item) => {
          if (item.id == "31") {
            item.disabled = true;
            item.childNode.forEach((item2) => {
              item2.disabled = true;
            });
          }
        });
        this.treeData = res.data.list;
        this.setTree(this.treeData);
      });
    },
    setTree(datas) {
      //设置树形默认选中的
      for (var i in datas) {
        if (datas[i].checked) {
          this.defaultTree.push(datas[i].id);
        }
        if (datas[i].childNode.length > 0) {
          this.setTree(datas[i].childNode);
        }
      }
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.defaultTree);
      });
    },
    cancel() {
      this.$emit("changeConnectDrawer", false);
    },
    confirm() {
      //关联资源和资源组
      this.checkedNodes = this.getCheckedNodes();
      this.$emit("comfirmConnect", this.checkedNodes);
    },
  },
};
</script>

<style lang="less" scoped>
.bottomBtns {
  text-align: left;
}
.titleName {
  // font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #343c6a;
  // letter-spacing: 0;
  font-weight: 400;
}
::v-deep .el-drawer__open .el-drawer.rtl {
  width: 660px !important;
}
</style>
